import IconeAjuda from '@/global/components/IconeAjuda'
import Grid from '@/global/components/ui/Grid'
import {
    FormDatePicker,
    FormField,
    FormFieldCheckbox,
    FormFieldTime,
    FormFile,
} from 'global/components/Form'
import { SelectEmpresa, SelectFuncionario } from 'global/components/Selects'
import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'

export default function FormNovaFaltaCadastrada() {
    const { watch, setValue } = useFormContext()
    const isInjustificada = watch('isInjustificada')
    const isReadOnly = watch('isReadOnly')

    useEffect(() => {
        if (isInjustificada) setValue('justificativa', '')
    }, [isInjustificada])

    return (
        <Grid container>
            <Grid item xs={6}>
                <SelectEmpresa variant="form" />
            </Grid>
            <Grid item xs={6}>
                <SelectFuncionario variant="form" />
            </Grid>
            <Grid item xs={4}>
                <FormDatePicker name="data" label="Data" type="date" required />
            </Grid>
            <Grid item xs={4}>
                <FormFieldTime
                    name="tempo"
                    label="Horas de falta"
                    endAdornment={
                        <IconeAjuda>
                            Caso informado, esse tempo será considerado como a
                            falta que você cadastrou e o resto do tempo de falta
                            do dia será considerado como o outro tipo de falta.
                            <br />
                            Deixe em branco para que o dia todo seja considerado
                            como o tipo de falta que você está cadastrando.
                            <br />
                            <br />
                            Exemplo: Se o funcionário tiver 5 horas de falta em
                            um dia e você informar 4 horas justificadas, o
                            sistema irá considerar 4 horas como falta
                            justificada e 1 hora como falta injustificada.
                        </IconeAjuda>
                    }
                />
            </Grid>
            <Grid item xs={4}>
                <FormFieldCheckbox
                    label="Injustificada"
                    name="isInjustificada"
                />
            </Grid>
            <Grid item xs={12}>
                <FormField
                    label="Justificativa"
                    name="justificativa"
                    required
                    multiline
                    max={190}
                    disabled={isInjustificada}
                />
            </Grid>
            <Grid item xs={12}>
                <FormFile
                    name="fileUrl"
                    disabled={isInjustificada || isReadOnly}
                />
            </Grid>
        </Grid>
    )
}
